import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { ChoiceItem } from "../../../../../pages/CourseAuthor/CourseInstruction/Parts/Exercises/Choice/Item/ChoiceItem";
import { ILocalizedChoiceExerciseItem } from "../../../../types";
import { chooseCorrectAnswer, localizedChoices } from "./Choices.helpers";
import { IChoicesProps } from "./Choices.types";

interface ISortChoiceProps extends IChoicesProps {
  choice: ILocalizedChoiceExerciseItem;
}

const SortChoiceItem = SortableElement((props: ISortChoiceProps) => {
  const { choice, enableEdit, exercise, currentLocale, operations } = props;

  return (
    <ChoiceItem
      canEdit={enableEdit}
      choice={choice}
      choiceExercise={exercise}
      currentLocale={currentLocale}
      deleteItem={operations.deleteExerciseItem(choice.id)}
      modifyHint={operations.modifyExerciseItemHint(choice.id)}
      modifyText={operations.modifyExerciseItemText(choice.id)}
      toggleCorrect={chooseCorrectAnswer({
        chooseMultipleChoiceAnswers: props.operations.modifyChoiceExerciseItemCorrect(choice.id),
        chooseSingleChoiceAnswer: props.chooseSingleChoiceAnswer,
        exercise: props.exercise,
      })(choice)}
    />
  );
});

export const SortChoiceList = SortableContainer((props: IChoicesProps) => {
  const choiceItems: ILocalizedChoiceExerciseItem[] = localizedChoices(props);

  return (
    <div>
      {choiceItems.map(choice => (
        <SortChoiceItem {...props} choice={choice} index={choice.sort} key={choice.id} />
      ))}
    </div>
  );
});
